module.exports = __webpack_public_path__ + "img/horizontal_7_3_7005.1160ae6d.png";